<section class="ai-patient-summary">
  @if (summaryAll && summaryAll.last_generation_date !== "" && !isLoading) {
    <div class="container-text">
      @if (!isEditing) {
        <div [innerHTML]="summaryAll.html"></div>
      }
      @if (isEditing) {
        <textarea
          class="markdown-editor"
          [value]="markdownContent"
          (input)="onMarkdownChange($event)"
        ></textarea>
      }
    </div>
  }

  @if ((!summaryAll || summaryAll.html === "") && !isLoading) {
    <div class="no-summary">
      <img
        src="assets/imgs/undraw/undraw_blank_canvas.svg"
        alt="Nessun Riassunto"
      />
      <span
        >Non hai ancora generato la Sintesi Complessiva, vai ad Analisi AI per
        generarla</span
      >
    </div>
  }

  @if (isLoading) {
    <div class="loading-container">
      <app-loader [size]="'big'"></app-loader>
    </div>
  }
</section>
